/**
 * Read the visitor's cookie-consent choice without importing the
 * CookieConsent UI component. Mirrors CookieConsent.jsx's cookie format
 * ({ strictly_necessary: true, analytics: boolean, timestamp }); returns null
 * when no valid choice is recorded.
 */
export const CONSENT_COOKIE_NAME = "cando_cookie_consent";

export function readConsent() {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp(`(^| )${CONSENT_COOKIE_NAME}=([^;]+)`));
  if (!match) return null;
  try {
    const parsed = JSON.parse(decodeURIComponent(match[2]));
    if (parsed && parsed.strictly_necessary === true && typeof parsed.analytics === "boolean") {
      return parsed;
    }
  } catch {
    /* legacy/invalid value */
  }
  return null;
}
